import React from 'react';
import { Tooltip } from './Tooltip';
import { getKeywordDefinition, hasKeywordDefinition } from '../../data/keywordDefinitions';

interface KeywordBadgeProps {
  keyword: string;
  value?: number | string;
  className?: string;
  showTooltip?: boolean;
}

export const KeywordBadge: React.FC<KeywordBadgeProps> = ({
  keyword,
  value,
  className = '',
  showTooltip = true
}) => {
  if (!keyword) {
    return null;
  }

  const definition = getKeywordDefinition(keyword);
  const hasDefinition = hasKeywordDefinition(keyword);
  
  const displayText = value !== undefined && value !== null ? `${keyword} ${value}` : keyword;

  const capitalizeFirstLetter = (val: string) => {
    return val.charAt(0).toUpperCase() + val.slice(1);
  }
  
  const badge = (
    <span
      className={`keyword ${className}`}
      style={{
        cursor: hasDefinition && showTooltip ? 'help' : 'default',
        textDecoration: hasDefinition && showTooltip ? 'underline dotted' : 'none',
        textDecorationColor: hasDefinition && showTooltip ? 'rgba(255, 255, 255, 0.5)' : 'transparent'
      }}
    >
      {capitalizeFirstLetter(displayText)}
    </span>
  );

  if (showTooltip && definition && definition.description) {
    return (
      <Tooltip content={definition.description} position="top">
        {badge}
      </Tooltip>
    );
  }

  return badge;
};
